package uk.co.nickthecoder.kyd

/*
 * We cannot use ExampleClass::class.qualifiedName, because that isn't supported in JS.
 * So instead, here's qualified class names.
 */
const val NoDirectorClassName = "uk.co.nickthecoder.kyd.NoDirector"
const val ManagementClassName = "uk.co.nickthecoder.kyd.Management"
const val StageClassName = "uk.co.nickthecoder.kyd.Stage"
const val ZOrderStageClassName = "uk.co.nickthecoder.kyd.ZOrderStage"
const val NoBehaviourClassName = "uk.co.nickthecoder.kyd.NoBehaviour"

object KydTypeRegistry {

    private val managementFactory = mutableMapOf<String, (Game) -> Management>()

    private val directorFactory = mutableMapOf<String, () -> Director>()

    private val stageFactory = mutableMapOf<String, (String) -> Stage>()

    private val behaviourFactory = mutableMapOf<String, () -> Behaviour>()


    fun registerManagementType(type: String, creator: (Game) -> Management) {
        managementFactory[type] = creator
    }

    fun registerDirectorType(type: String, creator: () -> Director) {
        directorFactory[type] = creator
    }

    fun registerStageType(type: String, creator: (String) -> Stage) {
        stageFactory[type] = creator
    }

    fun registerBehaviourType(type: String, creator: () -> Behaviour) {
        behaviourFactory[type] = creator
    }


    fun createManagement(type: String, game: Game): Management {
        return managementFactory[type]?.invoke(game) ?: Management(game)
    }

    fun createDirector(type: String): Director {
        return directorFactory[type]?.invoke() ?: NoDirector
    }

    fun createStage(type: String, stageName: String): Stage {
        return stageFactory[type]?.invoke(stageName) ?: Stage(stageName)
    }

    fun createBehaviour(type: String): Behaviour {
        return behaviourFactory[type]?.invoke() ?: NoBehaviour
    }


    fun availableManagementTypes(): List<String> = managementFactory.keys.toList()

    fun availableDirectoryTypes(): List<String> = directorFactory.keys.toList()

    fun availableStageTypes(): List<String> = stageFactory.keys.toList()

    fun availableBehaviourTypes(): List<String> = behaviourFactory.keys.toList()


    fun reset() {
        behaviourFactory.clear()
        stageFactory.clear()

        // Register standard Management
        registerManagementType(ManagementClassName) { game -> Management(game) }

        // Register standard Directors
        registerDirectorType(NoDirectorClassName) { NoDirector }

        // Register standard stages
        registerStageType(StageClassName) { Stage(it) }
        registerStageType(ZOrderStageClassName) { ZOrderStage(it) }

        // Register standard Behaviours
        registerBehaviourType(NoBehaviourClassName) { NoBehaviour }

    }

    init {
        reset()
    }

}
